// export const BASEURL = 'http://145.223.18.33:4008'

// export const BASEURL = 'http://localhost:3000/api'
export const BASEURL = 'https://app.zokep.com/api'
// export const BARCODE_URL = 'http://localhost:3000'